import { useEffect } from 'react';

export default function SessionChecker() {
  useEffect(() => {
    const intervalId = setInterval(() => {
      // Skip check on login page
      if (window.location.pathname === '/login') return;

      const token = localStorage.getItem('token');
      // console.log('SessionChecker checking token:', token);

      if (!token) {
        clearInterval(intervalId);
        window.alert('Your session has expired. Please log in again.');
        window.location.replace('/login');
      }
    }, 1000 * 30);

    return () => clearInterval(intervalId);
  }, []);

  return null;
}
